// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "wrapper-3d5g-";
var _5 = "oneMethod-nDc9p";
var _6 = "details-3-60i";
var _7 = "details__total-TY68S";
var _8 = "details__parts-2D5N4";
var _9 = "content-2kkZI";
var _a = "content__title-2Ths3";
var _b = "tooltip-1A5Pf";
var _c = "content__tooltip-yBGgz";
var _d = "content__tooltip__text-2UNrx";
var _e = "payment__result-3sCOU";
var _f = "content__title__back-1Rg7_";
var _10 = "gateways-3gtMV";
var _11 = "gateways_hidden-yaPBU";
var _12 = "description-3EGpm";
var _13 = "cards-2suOV";
var _14 = "card-1APBW";
var _15 = "paylate-8K_W3";
var _16 = "paylate_asCard-3fnhp";
var _17 = "idram-LARWX";
var _18 = "mastercard-2yB1g";
var _19 = "visa-2trsV";
var _1a = "cards_header-2gfkH";
var _1b = "sbp-2tDUP";
var _1c = "sberpay-Bx8tj";
var _1d = "mir-3CAKP";
var _1e = "applepay-2Jdgs";
var _1f = "googlepay-KjnfF";
var _20 = "vakifbank-V92Vn";
var _21 = "yandexpay-1IBvT";
var _22 = "unionpay-195UG";
var _23 = "invoicebox-172yA";
var _24 = "kaspi-3VdxY";
var _25 = "podeli-wgsbP";
var _26 = "ffpBonus-3ZpIV";
var _27 = "uniQr-1SPu1";
var _28 = "timelimit-2XWDl";
var _29 = "details__totalItem-25Vn6";
var _2a = "details__button-3P7wi";
var _2b = "qiwi-3HSG1";
var _2c = "icon-ttJrq";
var _2d = "visible-30xgz";
var _2e = "bottom_notification-3CS2m";
var _2f = "summaryGroup_order-15YSH";
var _30 = "summaryGroup_priceParts-2bk6A";
var _31 = "summaryGroup_total-1Tyrc";
var _32 = "loader-J7XOe";
var _33 = "hidden-1Qdg4";
var _34 = "cards_noTitle-iVKW2";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "wrapper", _5 as "oneMethod", _6 as "details", _7 as "details__total", _8 as "details__parts", _9 as "content", _a as "content__title", _b as "tooltip", _c as "content__tooltip", _d as "content__tooltip__text", _e as "payment__result", _f as "content__title__back", _10 as "gateways", _11 as "gateways_hidden", _12 as "description", _13 as "cards", _14 as "card", _15 as "paylate", _16 as "paylate_asCard", _17 as "idram", _18 as "mastercard", _19 as "visa", _1a as "cards_header", _1b as "sbp", _1c as "sberpay", _1d as "mir", _1e as "applepay", _1f as "googlepay", _20 as "vakifbank", _21 as "yandexpay", _22 as "unionpay", _23 as "invoicebox", _24 as "kaspi", _25 as "podeli", _26 as "ffpBonus", _27 as "uniQr", _28 as "timelimit", _29 as "details__totalItem", _2a as "details__button", _2b as "qiwi", _2c as "icon", _2d as "visible", _2e as "bottom_notification", _2f as "summaryGroup_order", _30 as "summaryGroup_priceParts", _31 as "summaryGroup_total", _32 as "loader", _33 as "hidden", _34 as "cards_noTitle" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "wrapper": _4, "oneMethod": _5, "details": _6, "details__total": _7, "details__parts": _8, "content": _9, "content__title": _a, "tooltip": _b, "content__tooltip": _c, "content__tooltip__text": _d, "payment__result": _e, "content__title__back": _f, "gateways": _10, "gateways_hidden": _11, "description": _12, "cards": _13, "card": _14, "paylate": _15, "paylate_asCard": _16, "idram": _17, "mastercard": _18, "visa": _19, "cards_header": _1a, "sbp": _1b, "sberpay": _1c, "mir": _1d, "applepay": _1e, "googlepay": _1f, "vakifbank": _20, "yandexpay": _21, "unionpay": _22, "invoicebox": _23, "kaspi": _24, "podeli": _25, "ffpBonus": _26, "uniQr": _27, "timelimit": _28, "details__totalItem": _29, "details__button": _2a, "qiwi": _2b, "icon": _2c, "visible": _2d, "bottom_notification": _2e, "summaryGroup_order": _2f, "summaryGroup_priceParts": _30, "summaryGroup_total": _31, "loader": _32, "hidden": _33, "cards_noTitle": _34 }
